import { ACCIONES } from '@/resources/constants';

var ActionsMixin = {
  methods: {
    // Dado el listado de la tabla 'transicion' de bbdd comprobamos que es posible pasar del estadoActual al estadoAlcanzar
    canExecuteTransition(listadoTransiciones, estadoActual, estadoAlcanzar) {
      if (!listadoTransiciones)
        return false;

      let actions = listadoTransiciones.filter(transicion => transicion.estadoPrevio == estadoActual &&
        transicion.estadoPosterior == estadoAlcanzar);
      // TODO Igual hay que chequear permisos segun quien se logue en la aplicacion
      return (actions.length > 0);

    },
    // Dado el listado de estados predecesores de una accion de la tabla 'accion' de bbdd comprobamos que es posible aplicar la accion sobre el estadoActual
    canExecuteAction(listadoEstadosPredecesoresAccion, estadoActual) {
      if (listadoEstadosPredecesoresAccion) {
        return listadoEstadosPredecesoresAccion.estadosPredecesores.includes(estadoActual);
      }
      return false;
    },
    tipoRectificacionImpago() {
      return ACCIONES.ACCION_RECTIFICAR_IMPAGO;
    },
    tipoRectificacionPago() {
      return ACCIONES.ACCION_RECTIFICAR_PAGO;
    }
  }
};
export default ActionsMixin;